import AppleSignin from "react-apple-signin-auth"
import { EnvConstants } from "../../../../constants/envs"
import { AccessAPI } from "../../../../api/common/AccessAPI"
import axios, { AxiosError } from "axios"
import { notification } from "antd"

export default function AppleButton() {
  function appleResponse(response: any) {
    console.log(response)
    if ("error" in response) return
    AccessAPI.appleLogin(response.authorization.id_token)
      .then(() => {
        window.location.reload()
      })
      .catch((error: AxiosError) => {
        let errorMessage = "Qualcosa è andato storto"
        if (axios.isAxiosError(error)) {
          const responseMessage = error.response?.data.error.message
          if (responseMessage === "Mail already exists!") errorMessage = "L'email è già registrata"
        }
        notification.error({
          message: errorMessage,
          duration: 4,
        })
      })
  }
  return (
    <AppleSignin
      authOptions={{
        clientId: "it.comixtime.platform",
        scope: "name email",
        redirectURI:
          EnvConstants.ENV === EnvConstants.PRODUCTION
            ? "https://platform.comixtime.it"
            : "https://platform.comixtimestage.it",
        state: "state",
        nonce: "nonce",
        usePopup: true,
      }}
      onSuccess={(response: any) => appleResponse(response)}
      onError={(error: any) => console.error(error)}
      uiType={"dark"}
      buttonExtraChildren="Continua con Apple"
      className="signin-button apple-button"
    />
  )
}
